import { Outlet } from "react-router";

const User = () => {
	return <Outlet />;
};

export default User;
